var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16PxIconLocation = function Svg16PxIconLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.238c0 1.692.618 3.337 1.735 4.616L8 16l4.515-5.146a7.012 7.012 0 0 0 1.735-4.616C14.25 2.799 11.445 0 8 0S1.75 2.8 1.75 6.238Zm10.938 0a5.418 5.418 0 0 1-1.351 3.586L8 13.63 4.665 9.824a5.455 5.455 0 0 1-1.35-3.586 4.687 4.687 0 0 1 4.687-4.679 4.687 4.687 0 0 1 4.688 4.679h-.002Z",
    fill: "#7B8BAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 6.238A3.12 3.12 0 0 0 8 9.357a3.12 3.12 0 0 0 3.125-3.119A3.12 3.12 0 0 0 8 3.119a3.12 3.12 0 0 0-3.125 3.119Zm4.687 0c0 .858-.703 1.56-1.562 1.56-.86 0-1.562-.702-1.562-1.56 0-.858.703-1.56 1.562-1.56.86 0 1.562.702 1.562 1.56Z",
    fill: "#7B8BAD"
  })));
};
export default Svg16PxIconLocation;